// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__3fz-y","userIconImage":"userIconImage__31OQv","editButton":"editButton__YahOe","editPhotoForm":"editPhotoForm__88Kub"};